import React from 'react';
import moment from 'moment';
import { DatePicker, Row } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useSectionActionPlan } from '../context';
import { Label, FormWrapper } from '../components';

export function Deadline() {
	const { form_field_name } = useSectionActionPlan();
	return (
		<Row>
			<Label>{I18n.get('Deadline')}</Label>
			<FormWrapper name={[...form_field_name, 'deadline']}>
				<DatePicker
					format="L"
					placeholder={I18n.get('Deadline')}
					disabledDate={(current) => current < moment().subtract(1, 'day')}
				/>
			</FormWrapper>
		</Row>
	);
}
